import React, { useEffect, useState } from "react";
import { API_BASE } from "../api/config";
import LocationSelect from "../components/LocationSelect";
import "./AuditLogPanel.css";

function formatDate(value) {
  if (!value) return "-";
  return new Date(value).toLocaleString();
}

function shortId(value) {
  return String(value || "").slice(0, 8);
}

export default function AuditLogPanel() {
  const [action, setAction] = useState("ALL");
  const [location, setLocation] = useState("ALL");
  const [productCode, setProductCode] = useState("");
  const [limit, setLimit] = useState("100");
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  async function loadAuditLogs() {
    try {
      setLoading(true);
      setError("");

      const query = new URLSearchParams();
      query.set("module", "INVENTORY");
      query.set("action", action || "ALL");
      query.set("locationCode", location || "ALL");
      query.set("limit", limit || "100");

      if (productCode.trim()) {
        query.set("productCode", productCode.trim());
      }

      const response = await fetch(`${API_BASE}/api/erp/audit-logs?${query.toString()}`);
      const data = await response.json();

      if (!response.ok || data.success === false) {
        throw new Error(data.message || "Failed to load audit logs");
      }

      setRows(Array.isArray(data.rows) ? data.rows : []);
    } catch (err) {
      setError(err.message);
      setRows([]);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    loadAuditLogs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [action, location, limit]);

  return (
    <div className="auditLogPanel">
      <div className="auditLogPanel__head">
        <div>
          <div className="auditLogPanel__tag">AUDIT LOG</div>
          <h3>Inventory Audit Log</h3>
          <p>
            Request, approval, apply, stock movement history တွေကို စစ်ရန်။
          </p>
        </div>

        <button type="button" onClick={loadAuditLogs} disabled={loading}>
          {loading ? "Loading..." : "Refresh"}
        </button>
      </div>

      <div className="auditLogPanel__filters">
        <label>
          <span>Action</span>
          <select value={action} onChange={(e) => setAction(e.target.value)}>
            <option value="ALL">ALL</option>
            <option value="STOCK_ADJUSTMENT_REQUEST_CREATED">
              REQUEST CREATED
            </option>
            <option value="STOCK_ADJUSTMENT_STATUS_CHANGED">
              STATUS CHANGED
            </option>
            <option value="STOCK_MOVEMENT_CREATED">
              STOCK MOVEMENT
            </option>
          </select>
        </label>

        <label>
          <span>Location</span>
          <LocationSelect
            value={location}
            onChange={setLocation}
            type="ALL"
            includeAll={true}
            allLabel="All Locations"
          />
        </label>

        <label>
          <span>Search Code</span>
          <input
            value={productCode}
            onChange={(e) => setProductCode(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") loadAuditLogs();
            }}
            placeholder="Product code..."
          />
        </label>

        <label>
          <span>Limit</span>
          <select value={limit} onChange={(e) => setLimit(e.target.value)}>
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="200">200</option>
            <option value="500">500</option>
          </select>
        </label>

        <button type="button" onClick={loadAuditLogs} disabled={loading}>
          Search
        </button>
      </div>

      {error && <div className="auditLogPanel__error">{error}</div>}

      <div className="auditLogPanel__summary">
        Audit rows: <b>{rows.length}</b>
      </div>

      <div className="auditLogTableWrap">
        <table className="auditLogTable">
          <thead>
            <tr>
              <th>Time</th>
              <th>Action</th>
              <th>Entity</th>
              <th>Location</th>
              <th>Code</th>
              <th>Color</th>
              <th>Size</th>
              <th>Old Status</th>
              <th>New Status</th>
              <th>By</th>
              <th>Note</th>
            </tr>
          </thead>

          <tbody>
            {rows.length === 0 ? (
              <tr>
                <td colSpan="11" className="auditLogTable__empty">
                  No audit logs found. New actions after audit trigger will appear here.
                </td>
              </tr>
            ) : (
              rows.map((row) => (
                <tr key={row.id}>
                  <td>{formatDate(row.eventTime)}</td>
                  <td>
                    <span className="auditLogAction">{row.action}</span>
                  </td>
                  <td>
                    {row.entityType} / {shortId(row.entityId)}
                  </td>
                  <td>{row.locationCode || "-"}</td>
                  <td className="auditLogTable__code">{row.productCode || "-"}</td>
                  <td>{row.color || "-"}</td>
                  <td>{row.size || "-"}</td>
                  <td>{row.oldStatus || "-"}</td>
                  <td>
                    <span className={`auditLogStatus auditLogStatus--${String(row.newStatus || "").toLowerCase()}`}>
                      {row.newStatus || "-"}
                    </span>
                  </td>
                  <td>{row.performedBy || "-"}</td>
                  <td className="auditLogTable__note">{row.note || "-"}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
